export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIl9fVklURV9BU1NFVF9fRXdHVjZScFZfXyI="